import { history as historyRouter } from 'instantsearch.js/es/lib/routers'

import type { UiState } from 'instantsearch.js'

type RouteState = {
  query?: string
  page?: string
  region?: string[]
  state?: string[]
  status?: string[]
  organizations?: string[]
  universities?: string[]
  hitsPerPage?: string
}

const router = historyRouter<RouteState>({
  cleanUrlOnDispose: true,
})
const getStateMapping = ({ indexName }: { indexName: string; query?: string }) => ({
  stateToRoute(uiState: UiState): RouteState {
    const indexUiState = uiState[indexName]
    return {
      query: indexUiState.configure?.query || indexUiState.query || '',
      state: indexUiState.refinementList?.state,
      region: indexUiState.refinementList?.region,
      status: indexUiState.refinementList?.status,
      organizations: indexUiState.refinementList?.['organizations.name'],
      universities: indexUiState.refinementList?.['universities.acronym'],
    }
  },
  routeToState(routeState: RouteState): UiState {
    return {
      [indexName]: {
        query: routeState?.query,
        refinementList: {
          state: routeState?.state || [],
          region: routeState?.region || [],
          status: routeState?.status || [],
          'organizations.name': routeState?.organizations || [],
          'universities.acronym': routeState?.universities || [],
        },
      },
    }
  },
})

const getRouting = (indexName: string, query?: string) => ({
  router,
  stateMapping: getStateMapping({ indexName, query }),
})

export default getRouting
